import { Box, styled } from '@mui/material';
import { keyframes } from '@emotion/react';

const zoomIn = keyframes`
	0% {
		opacity: 0;
		transform: scale3d(.7,.7,.7);
	}
	80% {
		opacity: 0.7;
	}
`;

const pointJumps = keyframes`
	from, to {
		transform: translateZ(0);
	}
	45%, 50% {
    animation-timing-function: cubic-bezier(0.72, -0.01, 0.54, 1.54);
		transform: translate3d(0,-25px,0) scaleY(1.1);
	}
`;

const AnimatedSVG = styled('svg')`
  transform-origin: center;
  animation: ${zoomIn} 0.3s;
  opacity: 0.7;

  & .point {
    animation: ${pointJumps} 0.3s;
  }
  & .point1 {
    animation-delay: 0.2s;
  }
  & .point2 {
    animation-delay: 0.3s;
  }
  & .point3 {
    animation-delay: 0.4s;
  }
`;

export default function EmptyState() {
  return (
    <Box display="grid" justifyContent="center" alignItems="center">
      <AnimatedSVG width={575} height={130} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#a)">
          <g className="bubble">
            <g fill="#fff">
              <path d="M11 63.421a53.86 53.86 0 0 0 8.894 29.745 53.11 53.11 0 0 0 23.77 19.739 52.547 52.547 0 0 0 30.628 3.077 52.851 52.851 0 0 0 27.157-14.624 53.655 53.655 0 0 0 14.527-27.392 53.973 53.973 0 0 0-3.003-30.921 53.393 53.393 0 0 0-19.52-24.023A52.648 52.648 0 0 0 64 10c-14.043 0-27.512 5.626-37.45 15.642C16.615 35.658 11.02 49.246 11 63.422Z" />
              <path d="M18 103.483c-.003 2.275.581 4.5 1.678 6.394 1.097 1.893 2.658 3.37 4.485 4.243a8.795 8.795 0 0 0 5.779.661c1.94-.442 3.724-1.536 5.124-3.143 1.4-1.608 2.354-3.657 2.74-5.888.388-2.231.19-4.545-.566-6.647-.756-2.102-2.038-3.9-3.683-5.164C31.912 92.675 29.978 92 28 92c-2.65 0-5.19 1.21-7.066 3.362-1.875 2.153-2.93 5.074-2.934 8.121Z" />
            </g>
            <path
              d="M108.8 92.83a3.099 3.099 0 0 0-2.41 1.17c-11 14.07-25.82 22.1-42.17 22.1A50.392 50.392 0 0 1 34.38 106a2.421 2.421 0 0 0-2.63-.18l-8.47 4.82a.696.696 0 0 1-.826-.161.701.701 0 0 1-.074-.839l4.81-7.68a2.13 2.13 0 0 0-.27-2.58c-9-9.5-14.61-22.12-14.61-35.44 0-28.45 24.29-52.74 51.74-52.74 16.24 0 32.46 7.91 42.05 21.42a2.415 2.415 0 0 0 2 1h10a1.601 1.601 0 0 0 1.38-2.38C108.94 12.13 86.12 0 64.22 0 28.78 0 0 27.62 0 63.72a62.64 62.64 0 0 0 15 40.85L4.24 124a4.1 4.1 0 0 0 5.59 5.15l22.11-10.52a65.134 65.134 0 0 0 32.45 8.63c22.39 0 43.09-12 55.3-32a1.64 1.64 0 0 0-1.41-2.46l-9.48.03Z"
              fill="#096319"
            />
          </g>
          <path
            className="point point1"
            d="M42.4 57.19C43.7473 57.188 45.0649 57.5857 46.1861 58.3328C47.3073 59.0799 48.1818 60.1428 48.6987 61.387C49.2157 62.6312 49.352 64.0008 49.0903 65.3224C48.8287 66.6441 48.1809 67.8585 47.2289 68.8119C46.2769 69.7653 45.0635 70.4148 43.7422 70.6784C42.4209 70.942 41.0512 70.8077 39.8062 70.2926C38.5613 69.7774 37.4971 68.9046 36.7484 67.7845C35.9996 66.6644 35.6 65.3473 35.6 64C35.6 62.1956 36.3161 60.465 37.591 59.1881C38.866 57.9113 40.5956 57.1927 42.4 57.19Z"
            fill="#096319"
          />
          <path
            className="point point2"
            d="M58.3 64C58.3001 65.3473 58.6997 66.6644 59.4484 67.7845C60.1972 68.9046 61.2613 69.7774 62.5063 70.2926C63.7512 70.8077 65.121 70.942 66.4423 70.6784C67.7636 70.4148 68.977 69.7653 69.929 68.8119C70.881 67.8585 71.5288 66.6441 71.7904 65.3224C72.0521 64.0008 71.9158 62.6312 71.3988 61.387C70.8818 60.1428 70.0074 59.0799 68.8862 58.3328C67.765 57.5857 66.4474 57.188 65.1 57.19C63.2957 57.1927 61.5661 57.9113 60.2911 59.1881C59.0162 60.465 58.3 62.1956 58.3 64Z"
            fill="#096319"
          />
          <path
            className="point point3"
            d="M81 64C81 65.3473 81.3997 66.6644 82.1484 67.7845C82.8971 68.9046 83.9613 69.7774 85.2062 70.2926C86.4512 70.8077 87.821 70.942 89.1423 70.6784C90.4635 70.4148 91.6769 69.7653 92.6289 68.8119C93.5809 67.8585 94.2287 66.6441 94.4904 65.3224C94.752 64.0008 94.6157 62.6312 94.0988 61.387C93.5818 60.1428 92.7074 59.0799 91.5862 58.3328C90.4649 57.5857 89.1473 57.188 87.8 57.19C86.9062 57.19 86.0211 57.3662 85.1954 57.7086C84.3698 58.0509 83.6197 58.5527 82.9881 59.1852C82.3566 59.8177 81.8559 60.5685 81.5148 61.3947C81.1736 62.2209 80.9987 63.1062 81 64Z"
            fill="#096319"
          />
          <path
            className="text"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188.13 91.44c-15.89 0-27-12-27-28.51s11.43-28.51 26.77-28.51c12 0 22.2 8 23.94 19.15l-9.36 3.26c-.87-8-7-14-14.8-14-10 0-17.41 8.48-17.41 20s7.4 20 17.85 20a15.49 15.49 0 0 0 15.23-14.47l9.58 3c-2.17 11.81-12.62 20.08-24.8 20.08Zm65.61-1.31-.74-9.36C249.93 87 243.62 91 235.46 91c-10.45 0-18.72-6.53-18.72-16.54 0-7.83 5.44-13.49 13.71-14.36l18.72-2.18c2.18-.22 3.48-1.31 3.48-3.05V54c0-7-5.22-11.75-12.4-11.75-7.18 0-12.41 5-12.63 12.84l-9.57-1.3c1.09-11.54 10.44-19.37 22.41-19.37 12.19 0 20.9 8 20.9 19.37v25.46l.43 10.88h-8.05Zm-1.09-22.2v-3.7a9.752 9.752 0 0 1-3.7.87l-15.89 1.74c-4.78.66-7.39 3.27-7.39 7.19 0 4.78 4.56 8.27 10.66 8.27 9.58 0 16.32-6.1 16.32-14.37Zm48.86-31.56-.22 10.45a12.24 12.24 0 0 0-7.62-2.18c-7.4 0-12.62 6.75-12.84 15.89v29.6h-8.7V35.72h7.18l1 10.67c2.28-7.08 7.51-11.76 14.25-11.76 3.03 0 5.64.66 6.95 1.74Zm28.18 55.07c-15.24 0-26.55-12-26.55-28.51s11.1-28.51 26.11-28.51c14.8 0 25.14 11.75 25.14 28.07 0 1.2 0 2.61-.11 3.81h-41.57c.66 9.79 7.4 16.76 16.54 16.76 7.84 0 13.93-4.68 14.8-11.65l9.36 3.49c-2.17 9.57-12.41 16.54-23.72 16.54Zm15.78-33.52a15.998 15.998 0 0 0-16.33-15.34 16.382 16.382 0 0 0-16.54 15.34h32.87ZM406 91.44c-15.89 0-27-12-27-28.51s11.43-28.51 26.77-28.51c12 0 22.2 8 23.94 19.15l-9.36 3.26c-.87-8-7-14-14.8-14-10 0-17.41 8.48-17.41 20s7.4 20 17.85 20a15.491 15.491 0 0 0 15.21-14.46l9.58 3c-2.18 11.8-12.63 20.07-24.78 20.07Zm79.75-34.39v33.08H477V57.48c0-8.27-5.44-14.36-13.28-14.36-10 0-16.76 7.4-17 17.41v29.6h-8.71v-74h8.71v27.75c2.94-5.87 9.9-9.46 17.84-9.46 12.24 0 21.16 9.58 21.16 22.63h.03Zm44.72 33.08h8.03l-.44-10.88V53.79c0-11.37-8.7-19.37-20.89-19.37-11.97 0-21.33 7.83-22.42 19.37l9.58 1.3c.22-7.84 5.44-12.84 12.62-12.84 7.18 0 12.41 4.75 12.41 11.75v.87c0 1.74-1.31 2.83-3.49 3.05l-18.71 2.18c-8.27.87-13.71 6.53-13.71 14.36 0 10.01 8.27 16.54 18.71 16.54 8.16 0 14.48-4 17.55-10.23l.76 9.36Zm-1.08-22.2v-3.7a9.812 9.812 0 0 1-3.7.87l-15.89 1.74c-4.79.66-7.4 3.27-7.4 7.19 0 4.78 4.57 8.27 10.66 8.27 9.55 0 16.3-6.1 16.3-14.37h.03ZM544 36.05h3.49c3.69 0 5.87-2.72 5.87-7.08v-7.39h8.27v14.14h12.19v8.49h-12.15v31.56c0 4.35 3.05 6.74 7.4 6.74a20 20 0 0 0 5.66-.65l.22 8.27a19.623 19.623 0 0 1-7.84 1.31c-8.27 0-14.14-5.66-14.14-14.37V44.32H544v-8.27Z"
            fill="#096319"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h574.95v129.58H0z" />
          </clipPath>
        </defs>
      </AnimatedSVG>
    </Box>
  );
}
